module.exports = __webpack_public_path__ + "img/web1.96457bd7.png";